module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.doing.length > 0),
      expression: "row.doing.length>0"
    }],
    staticClass: "more-box"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main-solid"
  }), _vm._v(" "), _c('div', {
    staticClass: "train-box flex-between",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.row.doing), function(row, index) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'HuiyiApplyFormStep1',
          query: {
            saiqu_id: row.id
          }
        }),
        expression: "{name:'HuiyiApplyFormStep1',query:{saiqu_id:row.id}}"
      }],
      staticClass: "train-items"
    }, [_c('div', {
      staticClass: "train-items-top items-top1",
      style: ('background-image: linear-gradient(to right, #' + row.color[0] + ' , #' + row.color[1] + ');')
    }, [_c('div', [_c('div', {
      staticClass: "train-items-top-city"
    }, [_vm._v(_vm._s(row.location))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-time"
    }, [_vm._v(_vm._s(row.date_str))])]), _vm._v(" "), _c('div', {
      staticClass: "train-sing-up-btn"
    }, [_vm._v("报名")])]), _vm._v(" "), _c('div', {
      staticClass: "train-items-title"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('div', {
      staticClass: "flex-between"
    }, [_c('div', {
      staticClass: "train-items-time"
    }, [_vm._v(_vm._s(row.startdate))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-address"
    }, [_vm._v(_vm._s(row.province) + "·" + _vm._s(row.city))])])])
  }), 0)]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-active"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "solid solid2"
  }), _vm._v(" "), _c('span', {
    staticClass: "more-title"
  }, [_vm._v("正在报名\n\t\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/pic-homepage-Meetings-and-training1.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("首次注册")])]), _vm._v(" "), _c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/pic-homepage-Meetings-and-training2.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("报名申请")])]), _vm._v(" "), _c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/pic-homepage-Meetings-and-training3.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("咨询查询")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4c5cb12","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiList.vue
// module id = 2571
// module chunks = 0